import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Datetime from "react-datetime";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Select from "react-select";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import axios from "axios";
import {
  addNewNotification,
  searchLeadForOrder,
  searchGroup,
  searchNotification,
  sendNotification,
  searchGrouplead,
  gatAllOackage,
  sendNotificationForWatsApp,
  sendNotificationForm,
  gatAllOackageWithoutPagination,
  sendNotificationForminWatsapp,
  getOrganizationDataWithoutPagination,
} from "../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import ScreenLoader from "views/Components/screenLoader";
import InputColor from "react-input-color";
import Switch from "react-switch";
import SweetAlert from "react-bootstrap-sweetalert";
import { faSpinner } from "variables/faVariables";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class SendBulkNotifictaion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "1",
      sendTo: 4,
      package_logo: "",
      package_LogoData: "",
      errormessages: [],
      title: "",
      _notificationSystem: null,
      group_id: null,
      template_id: null,
      subscriberItems: [],
      subscriber_detail: [],
      titleError: null,
      content: "",
      contentError: null,
      link: "",
      gender: "",
      linkError: null,
      genderDisable: false,
      leadDisable: false,
      groupDisable: false,
      allDisable: false,
      subscriber: "",
      notificationTemplates: [],
      packageOptions: [],
      parentOrganizationOptions: [],
      organizations: [],
      group_info: [],
      isLoading: false,
      leadExcel: false,
      selectedFile: [],
      fileError: "",
      expire_after_days: "",
      expireAfterErr: "",
      alert: null,
      packageIds: [],
      parentOrganizationIds: [],
      isPackage: false,
      isParentOrganizationPackage: false,
      templateContent: "",
      watsAppText: "",
      wastAppMood: false,
      whatsApp: true,
      errorMessage: "",
      util_sheet_name: "",
      throwErrorMessage: null,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onSendNotification = this.onSendNotification.bind(this);
    this.onChange = this.onChange.bind(this);
    this.upload = this.upload.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.inputOnChangeSubscriber = this.inputOnChangeSubscriber.bind(this);
    this.onDownload = this.onDownload.bind(this);
  }

  onDownload = (e) => {
    const link = document.createElement("a");
    link.href =
      "https://s3.ap-south-1.amazonaws.com/admin.flash.health/email-content/leads+(1).xlsx";
    link.target = "_blank";
    // document.body.appendChild(link)
    link.click();
  };

  onSubscriberChange = (value) => {
    this.setState({
      subscriber: value,
    });
  };

  ConfirmAndCancelMessage(id) {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Fail!"
          onCancel={() => this.hideAlert()}
          cancelBtnBsStyle="info"
          cancelBtnText="Close"
          showConfirm={false}
          showCancel
        >
          Send notification job failed. Please check your file data and try
          again.
        </SweetAlert>
      ),
    });
  }

  hideAlert() {
    this.setState({
      alert: null,
      selectedFile: [],
    });
  }

  sendToParentSubscriber = async () => {
    //this.props.searching(this.state.name);c
    // alert("==="+this.state.name.trim()+"===")
    if (this.state.subscribername.length !== 0) {
      let compelte = 1;
      let pg_no = 1;
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      var city_id = this.state.city_id;
      await searchLeadForOrder(this.state.subscribername, obj).then((res) => {
        const data = res.data.data;
        let subscriberItems = [];
        res.data.data.map((x, i) => {
          subscriberItems.push({
            value: x.id,
            label: x.name + " (" + x.mobile_no + ")",
          });
        });
        this.setState({
          subscriber_detail: data,
          subscriberItems: subscriberItems,
        });
      });
    } else {
      this.setState({
        subscriberItems: [],
        subscriber_detail: [],
      });
    }
  };
  inputOnChangeSubscriber = (event) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      subscribername: event.target.value.trim(),
      typing: false,
      typingTimeout: setTimeout(function () {
        self.sendToParentSubscriber(self.state.subscribername);
      }, 300),
    });
  };
  inputOnChangeSubscriber = (event) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      subscribername: event.target.value.trim(),
      typing: false,
      typingTimeout: setTimeout(function () {
        self.sendToParentSubscriber(self.state.subscribername);
      }, 300),
    });
  };
  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Notification</b> - sent Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 3,
    });

    this.setState({
      status: "1",
      sendTo: 4,
      title: "",
      group_id: null,
      template_id: "",
      templateContent: "",
      content: "",
      link: "",
      gender: "",
      genderDisable: false,
      leadDisable: false,
      groupDisable: false,
      allDisable: false,
      isLoading: false,
      leadExcel: false,
      isPackage: false,
      isParentOrganizationPackage: false,
      expire_after_days: "",
      expireAfterErr: "",
      packageIds: [],
      parentOrganizationIds: [],
      watsAppText: "",
      package_LogoData: null,
      textMessageErr: "",
      subscriber: null,
      package_logo: "",
      errorMessage: "",
      selectedFile: [],
      util_sheet_name: "",
    });
  }
  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {getApiErrorMessage(error)}
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
    searchGrouplead(1, 0, 1, obj).then((res) => {
      this.setState({ group_info: res.data });
    });
    searchNotification(1, obj).then((res) => {
      this.setState({ notificationTemplates: res.data.data });
    });

    gatAllOackageWithoutPagination(obj).then((res) => {
      const packageOptions = res.data.data.map((item) => ({
        value: item.id,
        label: item.title,
      }));
      this.setState({ packageOptions });
    });

    getOrganizationDataWithoutPagination(obj).then((res) => {
      const organizations = res && res.data ? res.data : [];
      const parentOrganizationOptions = organizations.map((item) => ({
        value: item.id,
        label:
          Number(item.organization_type) === 2
            ? `${item.company_name} (Sub company)`
            : item.company_name,
      }));
      this.setState({ organizations, parentOrganizationOptions });
    });
  }

  getSelectedChildOrganizations = () => {
    if (!this.state.parentOrganizationIds.length) return [];

    const selectedOrganizationIds = this.state.parentOrganizationIds.map(
      (organization) => Number(organization.value)
    );

    return this.state.organizations.filter(
      (item) => selectedOrganizationIds.includes(Number(item.parent_org_id))
    );
  };

  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    if (name == "expire_after_days") {
      const re = /^[0-9]*$/;
      if (re.test(event.target.value) == true) {
        this.setState({
          [name]: value,
        });
      }
    } else {
      this.setState({
        [name]: value,
      });

      if (name === "template_id") {
        const selectedTemplate = this.state.notificationTemplates.find(
          (data) => data.id === Number(value)
        );
        this.setState({
          templateContent: selectedTemplate ? selectedTemplate.content : "",
        });
      }
    }

    if (name === "sendTo") {
      if (value == 1) {
        this.setState({
          genderDisable: true,
          leadDisable: false,
          groupDisable: false,
          allDisable: false,
          leadExcel: false,
          isPackage: false,
          isParentOrganizationPackage: false,
          packageIds: [],
          parentOrganizationIds: [],
        });
      } else if (value == 2) {
        this.setState({
          genderDisable: false,
          leadDisable: true,
          groupDisable: false,
          allDisable: false,
          leadExcel: false,
          isPackage: false,
          isParentOrganizationPackage: false,
          packageIds: [],
          parentOrganizationIds: [],
        });
      } else if (value == 3) {
        this.setState({
          genderDisable: false,
          leadDisable: false,
          groupDisable: true,
          allDisable: false,
          leadExcel: false,
          isPackage: false,
          isParentOrganizationPackage: false,
          packageIds: [],
          parentOrganizationIds: [],
        });
      } else if (value == 4) {
        this.setState({
          genderDisable: false,
          leadDisable: false,
          groupDisable: false,
          allDisable: true,
          leadExcel: false,
          isPackage: false,
          isParentOrganizationPackage: false,
          packageIds: [],
          parentOrganizationIds: [],
        });
      } else if (value == 5) {
        this.setState({
          genderDisable: false,
          leadDisable: false,
          groupDisable: false,
          allDisable: false,
          leadExcel: true,
          isPackage: false,
          isParentOrganizationPackage: false,
          packageIds: [],
          parentOrganizationIds: [],
        });
      } else if (value == 6) {
        this.setState({
          genderDisable: false,
          leadDisable: false,
          groupDisable: false,
          allDisable: false,
          leadExcel: false,
          isPackage: true,
          isParentOrganizationPackage: false,
          parentOrganizationIds: [],
        });
      } else if (value == 7) {
        this.setState({
          genderDisable: false,
          leadDisable: false,
          groupDisable: false,
          allDisable: false,
          leadExcel: false,
          isPackage: false,
          isParentOrganizationPackage: true,
          packageIds: [],
        });
      }
    }
  };
  onSendNotification = () => {
    this.setState({ errormessages: [] });
    let error = false;
    let textMessageErr = "";
    let selectPackageErr = "";
    let selectParentOrganizationErr = "";
    let lead_excel_lead_Error = "";

    if (this.state.watsAppText === "" || this.state.watsAppText === null) {
      error = true;
      textMessageErr = (
        <small className="text-danger">Text Note is required.</small>
      );
    } else {
      textMessageErr = "";
    }
    if (
      this.state.leadExcel === true &&
      this.state.wastAppMood === true &&
      (!this.state.util_sheet_name || this.state.util_sheet_name.trim() === "")
    ) {
      error = true;
      lead_excel_lead_Error = (
        <small className="text-danger">Excel sheet Name is required.</small>
      );
    }
    if (this.state.isPackage === true && this.state.packageIds.length === 0) {
      error = true;
      selectPackageErr = (
        <small className="text-danger">Package is required.</small>
      );
    }
    if (
      this.state.isParentOrganizationPackage === true &&
      this.state.parentOrganizationIds.length === 0
    ) {
      error = true;
      selectParentOrganizationErr = (
        <small className="text-danger">Parent organization is required.</small>
      );
    }

    this.setState({
      textMessageErr,
      selectPackageErr,
      selectParentOrganizationErr,
      lead_excel_lead_Error,
    });
    if (error) return;

    this.setState({ isLoading: true });
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var subscriber = "";

    if (this.state.subscriber && this.state.subscriber.value) {
      subscriber = this.state.subscriber.value;
    }
    if (this.state.sendTo == 5) {
      const formData = new FormData();
      formData.append("excel_file", this.state.selectedFile);
      formData.append("template_name", this.state.watsAppText);
      formData.append("expire_after", this.state.expire_after_days);
      formData.append("send_to", this.state.sendTo);
      formData.append("whatsApp", this.state.whatsApp);
      formData.append("media_url", this.state.package_LogoData);
      formData.append("catalog_id", "9999");
      formData.append("util_sheet_name", this.state.util_sheet_name);

      sendNotificationForminWatsapp(formData, obj)
        .then((res) => {
          this.handleSuccess("bl");
        })
        .catch((error) => {
          let message = "An unexpected error occurred.";
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            message = error.response.data.message;
          }
          this.handleInvalidTemplateError("bl", message);
          this.setState({ isLoading: false });
          // this.setState({
          //   isLoading: false,
          //   selectedFile: [],
          //   watsAppText: null,
          //   leadDisable: false,
          //   leadExcel: false,
          //   isPackage: false,
          //   package_LogoData: null,
          //   package_logo: "",
          // });
        });
    } else {
      sendNotificationForWatsApp(
        this.state.watsAppText,
        this.state.sendTo,
        subscriber,
        this.state.packageIds.map((packageOption) =>
          Number(packageOption.value)
        ),
        this.state.parentOrganizationIds.map((organization) =>
          Number(organization.value)
        ),
        this.state.whatsApp,
        this.state.package_LogoData ? this.state.package_LogoData : null,
        this.state.group_id,
        this.state.gender,
        this.state.expire_after_days,
        this.state.util_sheet_name,
        obj
      )
        .then((res) => {
          // if (res.data && res.data.success === false) {
          //   this.handleInvalidTemplateError("bl", res.data.message);
          //   this.setState({ isLoading: false });
          // }
          // this.setState({
          //   watsAppText: null,
          //   package_LogoData: null,
          //   isLoading: false,
          //   textMessageErr: "",
          //   packageId: null,
          //   package_logo: "",
          //   subscriber: null,
          //   watsAppText: null,
          //   leadDisable: false,
          //   leadExcel: false,
          //   isPackage: false,
          //   package_LogoData: null,
          //   selectedFile: [],
          //   package_logo: "",
          //   packageOptions: [],
          // });
          this.handleSuccess("bl");
        })
        .catch((error) => {
          let message = "An unexpected error occurred.";
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            message = error.response.data.message;
          }
          this.handleInvalidTemplateError("bl", message);
          this.setState({ isLoading: false });
        });
    }
  };
  handleInvalidTemplateError(position, message) {
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-attention"></span>,
      message: (
        <div>
          <b>{message}</b>
        </div>
      ),
      level: "error",
      position: position,
      autoDismiss: 15,
    });
  }

  onSubmit = () => {
    this.setState({ errormessages: [] });
    let error = false;
    var templateErr = "";
    var filesError = "";
    var selectPackageErr = "";
    var selectParentOrganizationErr = "";

    if (this.state.template_id == "" || this.state.template_id == null) {
      error = true;
      templateErr = (
        <small className="text-danger">Template is required.</small>
      );
    } else {
      templateErr = "";
    }

    if (this.state.selectedFile == []) {
      error = true;
      filesError = (
        <small className="text-danger">Please select lead file.</small>
      );
    } else {
      filesError = "";
    }
    if (this.state.isPackage === true && this.state.packageIds.length === 0) {
      error = true;
      selectPackageErr = (
        <small className="text-danger">Package is required.</small>
      );
    }
    if (
      this.state.isParentOrganizationPackage === true &&
      this.state.parentOrganizationIds.length === 0
    ) {
      error = true;
      selectParentOrganizationErr = (
        <small className="text-danger">Parent organization is required.</small>
      );
    }

    this.setState({
      titleError: templateErr,
      fileError: filesError,
      selectPackageErr,
      selectParentOrganizationErr,
    });

    if (!error) {
      this.setState({ isLoading: true });
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      var subscriber = "";

      if (this.state.subscriber && this.state.subscriber.value) {
        subscriber = this.state.subscriber.value;
      }

      if (this.state.sendTo == 5) {
        const formData = new FormData();
        formData.append("excel_file", this.state.selectedFile);
        formData.append("template_id", this.state.template_id);
        formData.append("expire_after", this.state.expire_after_days);
        formData.append("send_to", this.state.sendTo);

        sendNotificationForm(formData, obj)
          .then((res) => {
            if (res.data.success === false) {
              this.setState({ isLoading: false });
              this.ConfirmAndCancelMessage();
            } else if (res.data.success === true) {
              this.handleSuccess("bl");
            }
          })
          .catch((error) => {
            this.handleNetworkError("bl", error);
            this.setState({ isLoading: false });
          });
      } else {
        sendNotification(
          this.state.template_id,
          this.state.sendTo,
          subscriber,
          this.state.group_id,
          this.state.gender,
          this.state.expire_after_days,
          this.state.packageIds.map((packageOption) =>
            Number(packageOption.value)
          ),
          this.state.parentOrganizationIds.map((organization) =>
            Number(organization.value)
          ),
          obj
        )
          .then((res) => {
            if (res.data.success === false) {
              this.setState({ isLoading: false });
            } else if (res.data.success === true) {
              this.setState({
                packageIds: [],
                parentOrganizationIds: [],
              });
              this.handleSuccess("bl");
            }
          })
          .catch((error) => {
            this.handleNetworkError("bl", error);
            this.setState({ isLoading: false });
          });
      }
    }
  };

  upload() {
    document.getElementById("selectLeadExcelFile").click();
    this.setState({
      selectedFile: [],
      fileError: "",
    });
  }

  handleFileChange(event) {
    if (event.target.files.length > 0) {
      if (
        event.target.files[0].name.includes(".xlsx") ||
        event.target.files[0].name.includes(".xlsm") ||
        event.target.files[0].name.includes(".xlsb") ||
        event.target.files[0].name.includes(".xltx") ||
        event.target.files[0].name.includes(".xltm") ||
        event.target.files[0].name.includes(".xls") ||
        event.target.files[0].name.includes(".xlt") ||
        event.target.files[0].name.includes(".xml") ||
        event.target.files[0].name.includes(".xlam") ||
        event.target.files[0].name.includes(".xla") ||
        event.target.files[0].name.includes(".xlw") ||
        event.target.files[0].name.includes(".xlr")
      ) {
        this.setState({
          selectedFile: event.target.files[0],
          fileError: "",
        });
      } else {
        this.setState({
          fileError: <small className="text-danger">Invalid file format</small>,
        });
      }
    }
  }
  uploadImage() {
    document.getElementById("selectImage").click();
  }
  handleFileImageChange = async (e) => {
    const file = e.target.files[0];

    this.setState({ processing: true });
    const fdata = new FormData();
    fdata.append("company_logo", file);
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const url = process.env.REACT_APP_NOT_SECRET_CODE + "/b2b/comapany/logo";
    try {
      const res = await axios.post(url, fdata, {
        headers: {
          Authorization: "Bearer " + obj,
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          "X-Request-Id": "124",
        },
      });
      const imageUrl = res.data.data.company_logo_url;
      this.setState({
        package_LogoData: imageUrl,
        package_logo: file,
        processing: false,
      });
    } catch (error) {
      this.setState({ processing: false });
    }
  };
  handleRemoveMedia = () => {
    this.setState({
      package_LogoData: null,
      selectedFile: [],
      package_logo: "",
    });
  };

  render() {
    const errormessages = this.state.errormessages;
    return (
      <div className="main-content">
        <input
          style={{ width: "0px", height: "0px", border: "none" }}
          type="text"
          ref={this.coupon_code_error}
        />
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />

          <Row>
            <Col md={6}>
              <Card
                content={
                  <form>
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}
                    <FormGroup>
                      <br></br>
                      <ControlLabel style={{ display: "block" }}>
                        Notification channel
                      </ControlLabel>
                      <div
                        className="OrderType_switch"
                        style={{ marginTop: 16, marginBottom: 16 }}
                      >
                        <Switch
                          checked={this.state.wastAppMood}
                          onChange={(e) => {
                            const isWhatsapp = !this.state.wastAppMood;
                            this.setState({
                              wastAppMood: isWhatsapp,
                              watsAppText: "",
                              package_LogoData: "",
                              package_logo: "",
                            });
                          }}
                          onColor="#24cc63"
                          offColor="#24cc63"
                          onHandleColor="#f7f7f7"
                          offHandleColor="#6c757d"
                          height={32}
                          width={70}
                          uncheckedIcon={
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "100%",
                                width: "92%",
                                color: "#ffffff",
                                fontSize: "23px",
                              }}
                            >
                              <i className="fas fa-comment-alt"></i>
                            </div>
                          }
                          checkedIcon={
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "93%",
                                width: "110%",
                                color: "white",
                                fontSize: "27px",
                              }}
                            >
                              <i className="fab fa-whatsapp"></i>
                            </div>
                          }
                          className="react-switch"
                          id="small-radius-switch"
                        />
                      </div>
                    </FormGroup>
                    {!this.state.wastAppMood ? (
                      <>
                        <FormGroup>
                          <ControlLabel>Template ID</ControlLabel>
                          <select
                            className=" primary form-control"
                            name="template_id"
                            value={this.state.template_id}
                            onChange={(e) => {
                              this.onChange(e);
                              this.setState({
                                titleError: "",
                              });
                            }}
                          >
                            <option value="">Select template</option>
                            {this.state.notificationTemplates.map((cus) => (
                              <option value={cus.id}>{cus.title}</option>
                            ))}
                          </select>
                          {this.state.titleError}
                        </FormGroup>

                        <FormGroup>
                          <ControlLabel>Expire after (days)</ControlLabel>
                          <FormControl
                            type="number"
                            name="expire_after_days"
                            value={this.state.expire_after_days}
                            onChange={(e) => {
                              this.onChange(e);
                              this.setState({
                                expireAfterErr: "",
                              });
                            }}
                            placeholder="Enter expire after days"
                          />
                          {this.state.expireAfterErr}
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Send To</ControlLabel>
                          <div className="sendto">
                            <Radio
                              style={{ display: "inline-block" }}
                              number="5"
                              option="1"
                              name="sendTo"
                              onChange={this.onChange}
                              checked={String(this.state.sendTo) === "1"}
                              label="Gender wise"
                            />

                            <Radio
                              style={{ display: "inline-block" }}
                              number="6"
                              option="2"
                              name="sendTo"
                              onChange={this.onChange}
                              checked={String(this.state.sendTo) === "2"}
                              label="Individual customer"
                            />
                            <Radio
                              style={{ display: "inline-block" }}
                              number="7"
                              option="3"
                              name="sendTo"
                              onChange={this.onChange}
                              checked={String(this.state.sendTo) === "3"}
                              label="B2C group"
                            />
                            <Radio
                              style={{ display: "inline-block" }}
                              number="8"
                              option="4"
                              name="sendTo"
                              onChange={this.onChange}
                              checked={String(this.state.sendTo) === "4"}
                              label="All customer"
                            />
                            <Radio
                              style={{ display: "inline-block" }}
                              number="99"
                              option="5"
                              name="sendTo"
                              onChange={this.onChange}
                              checked={String(this.state.sendTo) === "5"}
                              label="Upload lead excel"
                            />
                            <Radio
                              style={{ display: "inline-block" }}
                              number="991"
                              option="6"
                              name="sendTo"
                              onChange={this.onChange}
                              checked={String(this.state.sendTo) === "6"}
                              label="Package"
                            />
                            <Radio
                              style={{ display: "inline-block" }}
                              number="992"
                              option="7"
                              name="sendTo"
                              onChange={this.onChange}
                              checked={String(this.state.sendTo) === "7"}
                              label="Parent organization package"
                            />
                          </div>
                        </FormGroup>
                      </>
                    ) : (
                      <>
                        <Row>
                          <Col
                            md={12}
                            xs={12}
                            sm={12}
                            lg={12}
                            style={{ marginLeft: "1px", width: "100%" }}
                          >
                            <FormGroup>
                              <ControlLabel>Template Name</ControlLabel>
                              <textarea
                                style={{ resize: "none" }}
                                className="form-control"
                                rows="4"
                                cols="5"
                                placeholder="Enter Note"
                                onChange={(event) => {
                                  const noSpaceText =
                                    event.target.value.replace(/\s+/g, "");
                                  this.setState({
                                    watsAppText: noSpaceText,
                                    textMessageErr: "",
                                  });
                                }}
                                value={this.state.watsAppText}
                              />
                              {this.state.textMessageErr}
                            </FormGroup>
                          </Col>
                        </Row>
                        <FormGroup>
                          <ControlLabel>Media Upload</ControlLabel>
                          <br></br>
                          <input
                            style={{ display: "none" }}
                            id="selectImage"
                            type="file"
                            className="form-control"
                            // accept="image/*"
                            onChange={this.handleFileImageChange}
                          />
                          <Button
                            onClick={this.uploadImage}
                            style={{ color: "#2B3A41" }}
                          >
                            {" "}
                            <i
                              className={
                                this.state.package_logo == ""
                                  ? "fa fa-plus"
                                  : "fa fa-pencil fa-fw"
                              }
                            ></i>{" "}
                            {this.state.package_logo == ""
                              ? "Choose Image"
                              : "Change Image"}
                          </Button>
                          <div style={{ textAlign: "center" }}>
                            {this.state.package_LogoData && (
                              <>
                                <div
                                  style={{
                                    position: "relative",
                                    display: "inline-block",
                                  }}
                                >
                                  {this.state.package_LogoData
                                    .toLowerCase()
                                    .endsWith(".mp4") ? (
                                    <>
                                      <i
                                        className="fa fa-close"
                                        onClick={this.handleRemoveMedia}
                                        style={{
                                          position: "absolute",
                                          top: "9px",
                                          borderRadius: "3px",
                                          padding: "2px 0px",
                                          cursor: "pointer",
                                          zIndex: 2,
                                          color: "white",
                                          backgroundColor: "#CB0404",
                                          right: "0px",
                                        }}
                                      ></i>
                                      <video
                                        width="400"
                                        height="250"
                                        controls
                                        style={{ marginTop: 10 }}
                                      >
                                        <source
                                          src={this.state.package_LogoData}
                                          type="video/mp4"
                                        />
                                        Your browser does not support the video
                                        tag.
                                      </video>
                                    </>
                                  ) : (
                                    <>
                                      <i
                                        className="fa fa-close"
                                        onClick={this.handleRemoveMedia}
                                        style={{
                                          position: "absolute",
                                          top: "9px",
                                          borderRadius: "3px",
                                          padding: "2px 0px",
                                          cursor: "pointer",
                                          zIndex: 2,
                                          color: "white",
                                          backgroundColor: "#CB0404",
                                          right: "0px",
                                        }}
                                      ></i>
                                      <img
                                        src={this.state.package_LogoData}
                                        alt="Uploaded preview"
                                        style={{
                                          width: "220px",
                                          height: "230px",
                                          marginTop: 10,
                                        }}
                                      />
                                    </>
                                  )}
                                </div>
                              </>
                            )}
                          </div>

                          {/* {this.state.package_logoErr} */}
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Send To</ControlLabel>
                          <div className="sendto">
                            {/* <Radio
                              style={{ display: "inline-block" }}
                              number="5"
                              option="1"
                              name="sendTo"
                              onChange={this.onChange}
                              checked={String(this.state.sendTo) === "1"}
                              label="Gender wise"
                            /> */}

                            <Radio
                              style={{ display: "inline-block" }}
                              number="6"
                              option="2"
                              name="sendTo"
                              onChange={this.onChange}
                              checked={String(this.state.sendTo) === "2"}
                              label="Individual customer"
                            />
                            {/* <Radio
                              style={{ display: "inline-block" }}
                              number="7"
                              option="3"
                              name="sendTo"
                              onChange={this.onChange}
                              checked={String(this.state.sendTo) === "3"}
                              label="B2C group"
                            /> */}
                            {/* <Radio
                              style={{ display: "inline-block" }}
                              number="8"
                              option="4"
                              name="sendTo"
                              onChange={this.onChange}
                              checked={String(this.state.sendTo) === "4"}
                              label="All customer"
                            /> */}
                            <Radio
                              style={{ display: "inline-block" }}
                              number="99"
                              option="5"
                              name="sendTo"
                              onChange={this.onChange}
                              checked={String(this.state.sendTo) === "5"}
                              label="Upload lead excel"
                            />
                            <Radio
                              style={{ display: "inline-block" }}
                              number="991"
                              option="6"
                              name="sendTo"
                              onChange={this.onChange}
                              checked={String(this.state.sendTo) === "6"}
                              label="Package"
                            />
                            <Radio
                              style={{ display: "inline-block" }}
                              number="992"
                              option="7"
                              name="sendTo"
                              onChange={this.onChange}
                              checked={String(this.state.sendTo) === "7"}
                              label="Parent organization package"
                            />
                          </div>
                        </FormGroup>
                      </>
                    )}
                    <FormGroup>
                      <div
                        style={{
                          display:
                            this.state.genderDisable == true ? "block" : "none",
                        }}
                      >
                        <ControlLabel> Select Gender</ControlLabel>
                        <Radio
                          style={{ display: "inline-block" }}
                          number="9"
                          option="male"
                          name="gender"
                          onChange={this.onChange}
                          checked={this.state.gender === "male"}
                          label="Male"
                        />
                        <Radio
                          style={{ display: "inline-block" }}
                          number="10"
                          option="female"
                          name="gender"
                          onChange={this.onChange}
                          checked={this.state.gender === "female"}
                          label="Female"
                        />
                        <Radio
                          style={{ display: "inline-block" }}
                          number="11"
                          option="others"
                          name="gender"
                          onChange={this.onChange}
                          checked={this.state.gender === "others"}
                          label="Others"
                        />
                      </div>
                    </FormGroup>

                    <div
                      style={{
                        display:
                          this.state.leadDisable == true ? "block" : "none",
                      }}
                    >
                      <FormGroup>
                        <ControlLabel>Select Customer</ControlLabel>
                        <div
                          onKeyUp={(e) => this.inputOnChangeSubscriber(e)}
                          className="Appy2"
                          style={{ textTransform: "capitalize" }}
                        >
                          <Select
                            style={{ textTransform: "capitalize" }}
                            className="react-select primary"
                            classNamePrefix="react-select"
                            name="subscriber"
                            value={this.state.healthcondition}
                            onChange={(value) => this.onSubscriberChange(value)}
                            options={this.state.subscriberItems}
                            placeholder="Subscriber"
                            noOptionsMessage={() => "Type Name or Phone Number"}
                          />
                        </div>
                        {this.state.assigncutomerError}
                      </FormGroup>
                    </div>

                    <div
                      style={{
                        display:
                          this.state.groupDisable == true ? "block" : "none",
                      }}
                    >
                      <FormGroup>
                        <ControlLabel> Select Group</ControlLabel>
                        <select
                          className=" primary form-control"
                          name="group_id"
                          value={this.state.group_id}
                          onChange={this.onChange}
                        >
                          <option value="0">Select Group</option>
                          {this.state.group_info.map((cus) => (
                            <option value={cus.id}>{cus.group_name}</option>
                          ))}
                        </select>
                      </FormGroup>
                    </div>
                    <div
                      style={{
                        display:
                          this.state.isPackage == true ? "block" : "none",
                      }}
                    >
                      <FormGroup>
                        <ControlLabel>Select Packages</ControlLabel>
                        <Select
                          isMulti
                          closeMenuOnSelect={false}
                          className="react-select info"
                          classNamePrefix="react-select"
                          placeholder="Select Packages"
                          name="packageIds"
                          value={this.state.packageIds}
                          onChange={(value) => {
                            this.setState({
                              packageIds: value || [],
                              selectPackageErr: "",
                            });
                          }}
                          options={this.state.packageOptions}
                        />
                        {this.state.selectPackageErr}
                      </FormGroup>
                    </div>
                    <div
                      style={{
                        display:
                          this.state.isParentOrganizationPackage == true
                            ? "block"
                            : "none",
                      }}
                    >
                      <FormGroup>
                        <ControlLabel>Select Parent Organizations</ControlLabel>
                        <Select
                          isMulti
                          closeMenuOnSelect={false}
                          className="react-select info"
                          classNamePrefix="react-select"
                          placeholder="Select Parent Organizations"
                          name="parentOrganizationIds"
                          value={this.state.parentOrganizationIds}
                          onChange={(value) => {
                            this.setState({
                              parentOrganizationIds: value || [],
                              selectParentOrganizationErr: "",
                            });
                          }}
                          options={this.state.parentOrganizationOptions}
                        />
                        {this.state.selectParentOrganizationErr}
                        {this.state.parentOrganizationIds.length > 0 && (
                          <div
                            style={{
                              marginTop: "8px",
                              padding: "10px",
                              border: "1px solid #e5e5e5",
                              borderRadius: "4px",
                              background: "#fafafa",
                              color: "#555",
                            }}
                          >
                            <div style={{ fontWeight: 600 }}>
                              Included organizations
                            </div>
                            <ul
                              style={{
                                marginTop: "6px",
                                marginBottom: 0,
                                paddingLeft: "18px",
                              }}
                            >
                              {this.state.parentOrganizationIds.map(
                                (organization) => (
                                  <li key={organization.value}>
                                    {organization.label.replace(
                                      " (Sub company)",
                                      ""
                                    )}
                                  </li>
                                )
                              )}
                            </ul>
                            {this.getSelectedChildOrganizations().length >
                              0 && (
                              <ul
                                style={{
                                  marginTop: "6px",
                                  marginBottom: 0,
                                  paddingLeft: "18px",
                                }}
                              >
                                {this.getSelectedChildOrganizations().map(
                                  (organization) => (
                                    <li key={organization.id}>
                                      {organization.company_name}
                                    </li>
                                  )
                                )}
                              </ul>
                            )}
                            {this.getSelectedChildOrganizations().length ===
                              0 && (
                              <div style={{ marginTop: "4px" }}>
                                No sub-companies found for this organization.
                              </div>
                            )}
                          </div>
                        )}
                      </FormGroup>
                    </div>
                    {/* {!this.state.wastAppMood ? ( */}
                    <div style={{ display: "flex", gap: "10px" }}>
                      <div
                        style={{
                          display:
                            this.state.leadExcel == true ? "block" : "none",
                        }}
                      >
                        <FormGroup style={{ marginBottom: "3px" }}>
                          <ControlLabel style={{ display: "block" }}>
                            Upload Lead Excel
                          </ControlLabel>
                          <input
                            style={{ display: "none" }}
                            id="selectLeadExcelFile"
                            type="file"
                            // value={x.selectedFile}
                            className="form-control"
                            multiple
                            name="selectedFile"
                            onChange={this.handleFileChange}
                          />
                          <Button
                            onClick={this.upload}
                            style={{ color: "#2B3A41" }}
                          >
                            {" "}
                            <i
                              className={
                                this.state.selectedFile.length == 0
                                  ? "fa fa-plus"
                                  : "fa fa-pencil fa-fw"
                              }
                            ></i>{" "}
                            {this.state.selectedFile.length == 0
                              ? "Choose File"
                              : "Change File"}
                          </Button>
                          <div
                            style={{ display: "initial", marginLeft: "15px" }}
                          >
                            <Button
                              class="btn-color"
                              onClick={this.onDownload.bind(this)}
                              fill
                            >
                              Download Sample Excel
                            </Button>
                          </div>
                          <div style={{ marginTop: "10px" }}>
                            {this.state.selectedFile != []
                              ? this.state.selectedFile.name
                              : ""}
                          </div>
                        </FormGroup>
                        <p style={{ fontSize: "medium", marginBottom: "5px" }}>
                          {this.state.fileError}
                        </p>
                        <Row>
                          <Col
                            md={12}
                            sm={4}
                            style={{
                              display:
                                this.state.leadExcel == true &&
                                this.state.wastAppMood == true
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <FormGroup style={{ padding: "0" }}>
                              <ControlLabel>Campaign Name</ControlLabel>
                              <FormControl
                                style={{
                                  display: "initial",
                                  marginLeft: "-1px",
                                }}
                                type="text"
                                name="util_sheet_name"
                                value={this.state.util_sheet_name}
                                onChange={(e) => {
                                  this.onChange(e);
                                  this.setState({
                                    lead_excel_lead_Error: "",
                                  });
                                }}
                              ></FormControl>
                              {this.state.lead_excel_lead_Error}
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>
                    </div>

                    {!this.state.wastAppMood ? (
                      <Button
                        onClick={this.onSubmit.bind(this)}
                        className="btn-color"
                        disabled={this.state.isLoading}
                        fill
                      >
                        Send notification
                      </Button>
                    ) : (
                      <Button
                        onClick={this.onSendNotification.bind(this)}
                        className="btn-color"
                        disabled={this.state.isLoading}
                        fill
                      >
                        Send notification
                      </Button>
                    )}
                  </form>
                }
              />
            </Col>
            {this.state.template_id && !this.state.wastAppMood ? (
              <Col md={6}>
                <div
                  style={{
                    background: "white",
                    marginTop: "20px",
                    padding: "5px",
                  }}
                >
                  <ControlLabel>Template content</ControlLabel>
                  <p>{this.state.templateContent}</p>
                </div>
              </Col>
            ) : null}
          </Row>
        </Grid>
        {this.state.isLoading ? <ScreenLoader /> : ""}
      </div>
    );
  }
}

export default SendBulkNotifictaion;
